<template>
  <div>
    <deal-form
      v-if="showDealForm"
      :deal-id="dealId"
      @close="showDealForm = false"
      :modal-visible="showDealForm"
    />
    <vonap-window
      width="1300px"
      height="550px"
      title="Exposure Drilldown"
      @close="$emit('input', false)"
      v-model="value"
    >
      <page-toolbar>
        <kendo-button icon="add" title="Create deal" @click="openDealForm(0)"></kendo-button>
        <kendo-button icon="excel" title="Export to excel" @click="exportToExcel"></kendo-button>
      </page-toolbar>
      <kendo-grid :data-source="dataSource" height="470px" :pageable="true">
        <kendo-grid-column
          field="number"
          title="Number"
          width="100px"
          :attributes="{style: 'text-align: left;'}"
          template='<a data-dealid="#=dealId#" href="javascript:;" class="dealCodeLink" >#=number#</a>'
          :locked="true"
          :lockable="false"
        />
        <kendo-grid-column field="status" title="Status" width="100px" />
        <kendo-grid-column field="sector" title="Sector" width="100px" />
        <kendo-grid-column field="hedgeType" title="Hedge Type" width="75px" />
        <kendo-grid-column field="division" title="Division" width="150px" />
        <kendo-grid-column field="counterparty" title="Counterparty" width="100px" />
        <kendo-grid-column field="leg" title="Leg" width="100px" />
        <kendo-grid-column
          field="tradeDate"
          title="Trade Date"
          format="{0:yyyy-MM-dd}"
          width="100px"
          :attributes="{style: 'text-align: right;'}"
        />
        <kendo-grid-column
          field="maturityDate"
          title="Maturity Date"
          format="{0:yyyy-MM-dd}"
          width="120px"
          :attributes="{style: 'text-align: right;'}"
        />
        <kendo-grid-column field="buySell" title="Buy/Sell" width="75px" />
        <kendo-grid-column
          field="amountCcy1"
          title="Amount Ccy #1"
          format="{0:N0}"
          width="120px"
          :attributes="{class: 'numericColumn'}"
          :aggregates="['sum']"
          footerTemplate="<div style='text-align: right'>#=kendo.toString(data.hedgeAmount.sum, '\#\#,\#;\#\#,\#') # </div>"
        />
        <kendo-grid-column field="ccy1" title="Ccy1" width="60px" />
        <kendo-grid-column
          field="amountCcy2"
          title="Amount Ccy #2"
          format="{0:N0}"
          width="120px"
          :attributes="{class: 'numericColumn'}"
        />
        <kendo-grid-column field="ccy2" title="Ccy #2" width="75px" />
        <kendo-grid-column
          field="hedgeRate"
          title="FX Rate"
          format="{0:N4}"
          width="100px"
          :attributes="{class: 'numericColumn'}"
        />
        <kendo-grid-column
          field="collarRate"
          title="Collar Rate"
          format="{0:N4}"
          width="100px"
          :attributes="{class: 'numericColumn'}"
        />
        <kendo-grid-column field="description" title="Description" width="300px" />
        <kendo-grid-column
          field="lastModified"
          title="Last Modified"
          format="{0:yyyy-MM-dd hh:mm:ss}"
          width="180px"
        />
        <kendo-grid-column field="lastUser" title="Last User" width="150px" />
      </kendo-grid>
    </vonap-window>
  </div>
</template>

<script>
import VonapWindow from '@/components/VonapWindow'
import PageToolbar from '@/components/PageToolbar'
import DealForm from '@/views/List/Deal/DealForm'
import params from '@/helpers/params'
import {mapGetters} from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
    },
    reportParameters: {
      type: Object,
    },
  },
  mounted() {
    document.body.addEventListener('click', this.dealLinkClick, false)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.dealLinkClick)
  },
  data() {
    return {
      dealId: 0,
      showDealForm: false,
      dataSource: {
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/ExposureReport/hegdeDrillDownDataSource',
            data: () => this.reportParameters,
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'number',
            fields: {
              number: {type: 'string'},
              status: {type: 'string'},
              sector: {type: 'string'},
              hedgeType: {type: 'string'},
              division: {type: 'string'},
              counterparty: {type: 'string'},
              leg: {type: 'string'},
              tradeDate: {type: 'date'},
              maturityDate: {type: 'date'},
              buySell: {type: 'string'},
              amountCcy1: {type: 'number'},
              hedgeAmount: {type: 'number'},
              ccy1: {type: 'string'},
              hedgeRate: {type: 'string'},
              collarRate: {type: 'string'},
              amountCcy2: {type: 'number'},
              ccy2: {type: 'string'},
              description: {type: 'string'},
              lastModified: {type: 'date'},
              lastUser: {type: 'string'},
            },
          },
        },
        pageSize: 15,
        aggregate: [{field: 'hedgeAmount', aggregate: 'sum'}],
      },
    }
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  methods: {
    openDealForm(dealId) {
      this.dealId = dealId
      this.showDealForm = true
    },
    exportToExcel() {
      const exportUrl = '/api/heroux/ExposureReport/exportDrillDownGridToExcel'
      const qs = params.fromObject({...this.reportParameters, t: this.tokenString})
      location.href = `${exportUrl}?${qs}`
    },
    dealLinkClick({target}) {
      if (!/dealCodeLink/.test(target.className)) return
      const dealId = target.dataset.dealid
      this.openDealForm(dealId)
    },
  },
  components: {
    VonapWindow,
    PageToolbar,
    DealForm,
  },
}
</script>
